const PettyComponent = () => import('@/views/finance/petty/PettyView')

export default [
    {
        path:'/PettyIndex',
        name:'PettyComponent',
        component:PettyComponent
    }
]